import React from "react";
import styles from "./index.module.scss";
import SkeletonC from "../../stories/common/skeleton";

const ListHeaderTitleSkeleton = ({ layout }: any) => {
  return (
    <>
        <div className={styles.ListHeaderList}>
          <div className={styles.first}>
            <SkeletonC width="80px" height="20px" />
          </div>
          <div className={styles.second}>
            <SkeletonC width="80px" height="20px" />
          </div>
          <div className={styles.third}>
            <SkeletonC width="50px" height="20px" />
          </div>
          <div className={styles.fourth}>

          <SkeletonC width="50px" height="20px" />
          </div>
        </div>
    </>
  );
};

export default ListHeaderTitleSkeleton;
